import { Stack, Typography, Button } from "@mui/material";

import { ReactComponent as IconTimer } from "../../images/iconTime.svg";

const styles = {
  span: {
    fontFamily: "Nunito",
    fontWeight: 400,
    fontSize: "14px",
    lineHeight: "29px",
    color: "#737373",
  },
  text: {
    fontFamily: "Nunito",
    fontSize: "18px",
    fontWeight: 400,
    lineHeight: "25px",
  },
};

export default function Timer({
  hours,
  minutes,
  seconds,
  setOpenCancelar,
  handleSalvarTudo,
  handleOpen,
}) {
  return (
    <Stack sx={{ background: "#EFF5F7", p: "8px", borderRadius: "5px" }}>
      <Typography sx={styles.span}>Duração</Typography>
      <Stack
        direction="row"
        sx={{
          display: "flex",
          alignItems: "center",
          gap: "16px",
          flexWrap: "wrap",
        }}
      >
        <IconTimer width="32px" height="32px" />
        <Typography
          sx={{
            ...styles.text,
            color: "#063F5E",
          }}
        >
          {hours.toString().padStart(2, "0")}:
          {minutes.toString().padStart(2, "0")}:
          {seconds.toString().padStart(2, "0")}
        </Typography>
        <Button
          sx={{ ...styles.text, textTransform: "none" }}
          variant="outlined"
          color="error"
          onClick={() => setOpenCancelar(true)}
        >
          Cancelar
        </Button>
        <Button
          sx={{
            ...styles.text,
            textTransform: "none",
            color: "#1E729F",
          }}
          variant="outlined"
          color="primary"
          onClick={handleSalvarTudo}
        >
          Salvar
        </Button>
        <Button
          sx={{
            ...styles.text,
            textTransform: "none",
            background: "#1E729F",
            boxShadow: "none",
          }}
          variant="contained"
          color="primary"
          onClick={() => handleOpen(true)}
        >
          Finalizar consulta
        </Button>
      </Stack>
    </Stack>
  );
}
